import React from 'react';
import ContentHubPage from './ContentHubPage';

const NewsCenter: React.FC = () => <ContentHubPage kind="news" />;

export default NewsCenter;
